import { EMPTY_STRING } from '../../../../constants/common'
import {
  isLegacyStoppedReply,
  isServiceUnavailableReply,
} from '../../../../utils/aiAgents'
import { GretaAIChatStatus } from '../../GretaAIChat.constants'
import { getIsGretaAIChatIdle } from '../../GretaAIChat.utils'
import {
  appendGretaAIChatAssistantMessage,
  appendGretaAIChatUserMessage,
  getGretaAIChatRenderableTurns,
  getIsGretaAIChatUserRole,
} from '../../GretaAIChatMessage'

function extractGretaAIChatCompletion(response) {
  const data = response?.data

  return (
    data?.choices?.[0]?.message?.content ??
    data?.message?.content ??
    data?.content ??
    EMPTY_STRING
  )
}

// A 200 can still carry no usable answer — the canned balance notice, or nothing.
function getGretaAIChatReplyStatus(reply) {
  if (isServiceUnavailableReply(reply)) {
    return GretaAIChatStatus.Unavailable
  }

  if (reply.trim().length === 0) {
    return GretaAIChatStatus.EmptyReply
  }

  return GretaAIChatStatus.Idle
}

export function getGretaAIChatCompletionMessages(messages) {
  return getGretaAIChatRenderableTurns(messages).map(message => ({
    content: message.text,
    role: message.role,
  }))
}

export function parseGretaAIChatReply(response) {
  const reply = extractGretaAIChatCompletion(response)
  const replyStatus = getGretaAIChatReplyStatus(reply)
  const isForeignStop = isLegacyStoppedReply(reply)

  return {
    delivered: getIsGretaAIChatIdle(replyStatus) && !isForeignStop,
    isForeignStop,
    reply,
    replyStatus,
  }
}

export function getGretaAIChatLastQuestion(messages) {
  return messages.at(-1).text
}

// Re-asks the pending question on top of the history the 409 wait reloaded.
export function getGretaAIChatConflictRetryMessages(
  reloadedMessages,
  payloadMessages
) {
  return reloadedMessages
    ? appendGretaAIChatUserMessage(
        reloadedMessages,
        getGretaAIChatLastQuestion(payloadMessages)
      )
    : payloadMessages
}

// A concurrent history reload can already carry this reply, so skip the append when
// it already tails the thread — otherwise the open chat shows it twice.
export function appendGretaAIChatAssistantReply(messages, reply) {
  const lastTurn = getGretaAIChatRenderableTurns(messages).at(-1)

  if (
    lastTurn &&
    !getIsGretaAIChatUserRole(lastTurn.role) &&
    lastTurn.text === reply
  ) {
    return messages
  }

  return appendGretaAIChatAssistantMessage(messages, reply)
}
